import React, { createContext, useContext, useMemo, useState } from 'react';

interface InputContextProps {
  files: string[];
}

const InputContext = createContext<InputContextProps | null>(null);

export const InputContextProvider = ({
  children,
}: {
  children: (setFiles: (files: string[]) => void) => React.ReactNode;
}) => {
  const [files, setFiles] = useState<string[]>([]);

  const value = useMemo(() => ({ files }), [files]);

  return (
    <InputContext.Provider value={value}>
      {children(setFiles)}
    </InputContext.Provider>
  );
};

export const useInputContext = () => {
  const inputContext = useContext(InputContext);
  if (!inputContext) {
    throw new Error('Cannot use useInputContext outside InputContext!');
  }

  return inputContext;
};
